import React from 'react';
import { useParams } from 'react-router';
import SiteRouteParamPicker from '../../common/pickers/SiteRouteParamPicker';
const SiteRouteParamConfigurator = ({ config, onChange }) => {
    return (React.createElement(SiteRouteParamPicker, { value: config === null || config === void 0 ? void 0 : config.paramKey, onChange: paramKey => {
            onChange === null || onChange === void 0 ? void 0 : onChange({ paramKey });
        } }));
};
export const SiteRouteParamPlugin = {
    name: 'Route Parameter',
    type: 'route-parameter',
    configurator: SiteRouteParamConfigurator,
    getParamValue: (config, context) => {
        const params = context.paramsContext;
        if (params && config.paramKey) {
            const paramValue = params[config.paramKey];
            if (paramValue === `:${config.paramKey}`) {
                return null;
            }
            else {
                return paramValue;
            }
        }
        return null;
    },
    useHook: () => {
        const paramsContext = useParams();
        return { paramsContext };
    }
};
//# sourceMappingURL=SiteRouteParamPlugin.js.map